import React from "react";
import "../../index.css";

const ErrorDisplay = ({ errorMessage, unavailable, onClose }) => {
  if (errorMessage !== "") {
    return (
      <div className="container">
        <section className="errorsec">
          <div className="errMsg">
            <h1 className="mainerror">Access Denied</h1>
            <h3 className="error">{errorMessage}</h3>
            <button className="btnclosewind clswindow" onClick={onClose}>
              Close Window
            </button>
          </div>
        </section>
      </div>
    );
  }

  if (unavailable === true) {
    return (
      <div className="container">
        <section className="errorsec">
          <div className="errMsg">
            <h2 className="mainerror">
              Images/Documents for this Service Appointment/WOLI are being
              processed or has been deleted.
            </h2>
            <h3 className="error">
              {
                "Please use file images option in Salesforce to view the images in the interim"
              }
            </h3>
            <button className="btnclosewind clswindow" onClick={onClose}>
              Close Window
            </button>
          </div>
        </section>
      </div>
    );
  }

  return null;
};

// ErrorDisplay.propTypes = {
//   errorMessage: PropTypes.string,
//   unavailable: PropTypes.bool,
//   onClose: PropTypes.func.isRequired,
// };

// ErrorDisplay.defaultProps = {
//   errorMessage: "",
//   unavailable: false,
// };

export default ErrorDisplay;
